var _title, _polyline, _ellipse, _path, _ellipse2, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOphosHead = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241.15,
    height: 300,
    viewBox: "0 0 241.15 300",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "grid_head")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "124.19 259.02 133.68 258.7 115.33 267.15",
    fill: "#cf2629"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.15,
    cy: 138.85,
    rx: 22.33,
    ry: 46.78,
    fill: "#212226"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.15,187.45C10.61,187.45,0,166.1,0,138.85s10.61-48.6,24.15-48.6S48.3,111.6,48.3,138.85,37.69,187.45,24.15,187.45Zm0-93.55c-11.11,0-20.5,20.59-20.5,45s9.39,45,20.5,45,20.5-20.59,20.5-45S35.26,93.9,24.15,93.9Z",
    fill: "#0091cb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217,
    cy: 138.85,
    rx: 22.33,
    ry: 46.78,
    fill: "#212226"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M217,187.45c-13.54,0-24.15-21.35-24.15-48.6s10.61-48.6,24.15-48.6,24.15,21.35,24.15,48.6S230.54,187.45,217,187.45Zm0-93.55c-11.11,0-20.5,20.59-20.5,45s9.39,45,20.5,45,20.5-20.59,20.5-45S228.11,93.9,217,93.9Z",
    fill: "#0091cb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.7,133.7c-19.37,78-32.29,163.68-108,164.47-64.49.68-87.52-91.28-108-164.47C-7,63.56,61,1.83,120.69,1.83S246.25,63,228.7,133.7Z",
    fill: "#141415"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120,300c-62.88,0-87.16-87.19-106.69-157.29l-2.38-8.52C2.71,104.89,9,74.44,28.75,48.47,51.08,19,87.17,0,120.68,0c32.43,0,67.66,18.25,89.74,46.49,20.46,26.17,27.58,57.29,20,87.64-1.76,7.08-3.46,14.21-5.17,21.35C208.43,226.17,191,299.26,120.7,300Zm.7-296.35c-32.41,0-67.36,18.46-89,47-19,25-25.12,54.36-17.23,82.53l2.38,8.52C37,214.22,59.88,296.35,120,296.35h.7c67.42-.71,83.78-69.2,101.09-141.71,1.71-7.14,3.41-14.29,5.17-21.38h0c7.26-29.24.38-59.25-19.37-84.52C186.13,21.35,152,3.65,120.68,3.65Z",
    fill: "#0091cb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M201.72,160.1c-14.55,62.69-24.25,131.55-81.11,132.19-48.43.54-65.72-73.36-81.11-132.19-14.74-56.37,36.31-106,81.11-106S214.91,103.29,201.72,160.1Z",
    fill: "#2d2d33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.31,65.29c17.51-17.6,41-28.38,66.85-28.38S170.51,47.69,188,65.29h16.5c-17.3-34-48.16-56.66-83.36-56.66S55.11,31.28,37.81,65.29Z",
    fill: "#1c566d"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.51,292.27",
    fill: "none",
    stroke: "#0091cb",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1,267.74l-3.45-1.18c29.59-86.45,11.18-140.39,10.17-143.2a9.62,9.62,0,0,0-6.44-4.77C65.84,115,38.2,133.09,37.92,133.28l-1.4.93-28-35.55,2.87-2.26,25.92,32.93C43.39,125.51,67,111.5,81.26,115a13.27,13.27,0,0,1,8.83,6.68l.1.23C90.4,122.5,110.77,178.13,80.1,267.74Z",
    fill: "#0091cb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M160.4,267.74C144.39,221,142.48,183.89,143.7,161c1.32-24.88,6.4-38.5,6.62-39.07l.1-.23a13.27,13.27,0,0,1,8.83-6.68c14.24-3.54,37.87,10.47,43.93,14.29L229.1,96.39,232,98.65,204,134.2l-1.4-.93c-.28-.18-27.89-18.31-42.46-14.7a9.62,9.62,0,0,0-6.44,4.77c-1,2.82-19.38,56.87,10.17,143.2Z",
    fill: "#0091cb"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOphosHead, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ophos-head.2599e805.svg";
export { ForwardRef as ReactComponent };